module.exports = __webpack_public_path__ + "static/media/info.f3c1f311.svg";